function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "CR",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Table-View-|-Survey/year",
  transform: "translate(-1023.000000, -421.000000)",
  fill: "#EFA54B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "sidebar",
  transform: "translate(1000.000000, 146.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "modify-copy",
  transform: "translate(0.000000, 256.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36,19 C43.176,19 49,24.824 49,32 C49,39.176 43.176,45 36,45 C28.824,45 23,39.176 23,32 C23,24.824 28.824,19 36,19 Z M37.5,31 L35,31 L35,38 L37.5,38 L37.5,31 Z M36.5,26 L36,26 C35.4477153,26 35,26.4477153 35,27 L35,27 L35,29 L37.5,29 L37.5,27 C37.5,26.4477153 37.0522847,26 36.5,26 L36.5,26 Z",
  id: "info"
})))));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.a93cb239.svg";
export { ForwardRef as ReactComponent };